  <p-table
    [value]="auditData"
    [virtualScroll]="true"
    [rows]="10"
    [scrollable]="true"
    scrollHeight="300px"
    [loading]="loading"
    [sortMode]="'multiple'"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="changedOn">Changed On <p-sortIcon field="changedOn"></p-sortIcon></th>
        <th pSortableColumn="changedBy">Changed By <p-sortIcon field="changedBy"></p-sortIcon></th>
        <th pSortableColumn="oldValue">Old Value <p-sortIcon field="oldValue"></p-sortIcon></th>
        <th pSortableColumn="newValue">New Value <p-sortIcon field="newValue"></p-sortIcon></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td>{{ row.changedOn | date:'MM/dd/yyyy HH:mm'}}</td>
        <td>{{ row.changedBy }}</td>
        <td>{{ row.oldValue | formatDate}}</td>
        <td>{{ row.newValue | formatDate}}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" >No audit data found.</td>
      </tr>
    </ng-template>
  </p-table>